import { Button } from '../components/primitives/index.js'
import SEO from '../components/SEO.jsx'

export default function NotFoundPage() {
  return (
    <div className="container" style={{ padding: '6rem 0', textAlign: 'center' }}>
      <SEO config={{ title: 'Page Not Found', robots: 'noindex, nofollow', titleRaw: true }} />
      <h1 style={{ fontSize: '2.5rem' }}>404</h1>
      <p style={{ color: 'var(--text-secondary)', margin: '0.75rem 0 2rem' }}>That page doesn&apos;t exist.</p>
      <Button to="/" variant="primary">
        Back home
      </Button>
    </div>
  )
}
